"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var image_1 = __importDefault(require("next/image"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var Languages = function (_a) {
    var languages = _a.languages;
    var t = (0, next_intl_1.useTranslations)('translation');
    var getPageWithNewLang = (0, apps_shared_1.usePageWithNewLang)();
    var currentLang = (0, next_intl_1.useLocale)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.langContainer },
        react_1.default.createElement("span", null, t('languages')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.langSet }, languages.map(function (lang) { return (react_1.default.createElement(react_1.default.Fragment, { key: "footer_lang".concat(lang.key) }, currentLang !== lang.key ? (react_1.default.createElement("a", { href: getPageWithNewLang(lang.key) },
            react_1.default.createElement(image_1.default, { src: "/img/footer/langs/".concat(lang.key, ".svg"), alt: lang.title + ' flag', width: 36, height: 24 }))) : (react_1.default.createElement(image_1.default, { src: "/img/footer/langs/".concat(lang.key, ".svg"), alt: lang.title + ' flag', width: 36, height: 24 })))); }))));
};
exports.default = Languages;
